import type { GQLError } from '../../resources';

export type BestAvailableVehicleImageInput = {
  year: number;
  make: string;
  model: string;
  trim: string | null;
  color: string | null;
};

export type BestAvailableVehicleImage = {
  year: number;
  make: string;
  model: string;
  trim: string | null;
  color: string | null;
  desktopImageUrl: string | null;
  mobileImageUrl: string | null;
  isGeneric: boolean;
  isExactImageMatch: boolean;
};

export type BestAvailableVehicleImageData = {
  bestAvailableVehicleImage: BestAvailableVehicleImage | null;
};

export type BestAvailableVehicleImageResponse = {
  data: BestAvailableVehicleImageData;
  errors?: GQLError[];
};

const getBestAvailableVehicleImageQuery = `
  query BestAvailableVehicleImage($input: GetBestAvailableVehicleImageInput!) {
    bestAvailableVehicleImage(input: $input) {
      year
      make
      model
      trim
      color
      desktopImageUrl
      mobileImageUrl
      isGeneric
      isExactImageMatch
    }
  }`;

export default getBestAvailableVehicleImageQuery;
